import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

export interface AvisarPendenciaRequest {
    numeroProtocolo: string;
    anoProtocolo: string;
    observacao?: string;
}

@Injectable({ providedIn: 'root' })
export class ServicoPendenciaService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.pendencia;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    avisarPendencia(idServico: number, ufCrm: string, request: AvisarPendenciaRequest, context?: HttpContext): Observable<void> {
        const params = new HttpParams().set('idServico', String(idServico)).set('uf_crm', ufCrm);
        return this.http.put<void>(this.PATH, request, { params, context });
    }
}
